import { render, staticRenderFns } from "./GcTailwindTooltip.vue?vue&type=template&id=1a9e9757&"
import script from "./GcTailwindTooltip.vue?vue&type=script&lang=ts&"
export * from "./GcTailwindTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./GcTailwindTooltip.vue?vue&type=style&index=0&id=1a9e9757&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports